export const allUsersColumns = [
    {
      id: 'emailUserAdministrator',
      label: 'Correo Usuario',
      numeric: true,
    },
    {
      id: 'rolUser',
      label: 'Roles Usuario',
      numeric: false,
    },
    {
      id: 'ActionUsuario',
      label: 'Aciones',
      numeric: false,
    },
  ];


  export const allUsersWihtoutCompanyColumns = [
    {
      id: 'emailUserAdministrator',
      label: 'Correo Usuario',
      numeric: true,
    },
    {
      id: 'ActionUsuario',
      label: 'Aciones',
      numeric: false,
    },
  ];
  